"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerOptions = void 0;
/**
 * @property {number}   timer             - Timer to finish the assessment
 * @property {boolean}  shuffleQuestions  - Shuffle questions
 * @property {boolean}  shuffleAnswers    - Shuffle answers
 * @property {boolean}  highlighter       - Highlighter annotation tool
 * @property {boolean}  notepad           - Notepad annotation tool
 * @property {boolean}  checkAnswers      - Allow students to check answers
 * @property {string}   calculator        - group up the different options from calculator
 */
var PlayerOptions = /** @class */ (function () {
    function PlayerOptions(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return PlayerOptions;
}());
exports.PlayerOptions = PlayerOptions;
